import React from 'react'
import { getProductOriginURL } from '../../../../../utils/config';
import SST_NAIL_ENUM from '../../../common/json/SST_NAIL_ENUM.json'
import { HANGER_TYPE } from '../../../common/constants';
import { getSSTNail } from '../../../common/fns';
import queryString from 'query-string'

// Legacy func
export const getFastenersLabel = (qty, nailEnum, isJFastener) => {
  const SSTNail = getSSTNail(nailEnum);

  const quantity = qty ?? ''
  const label = SSTNail ? SSTNail.label : `enum${nailEnum}`

  if (isJFastener) {
    return quantity ? `${quantity}-${label}` : label;
  }

  return quantity ? `${quantity}-${label}` : '-'
}

// This is for fastener display in Result Table and Job Tally
export const getFastenersDisplayLabel = (qty, nailEnum, isJFastener) => {
  const SSTNail = getSSTNail(nailEnum)

  if (!SSTNail) return '-'

  const quantity = qty ? `(${qty}) ` : ''
  const label = SSTNail ? SSTNail.displayLabel ?? SSTNail.label : `enum${nailEnum}`

  if (isJFastener) {
    return quantity ? quantity + label : label
  }

  return quantity ? quantity + label : '-'
}

export const displayFastenersAnchor = (nailEnum, label) => {
  const nail = getSSTNail(nailEnum);

  const productOrigin = getProductOriginURL();
  const productURL = nail && nail.url ? nail.url : ''

  const updatedLabel = <>
    <p>{label.substring(0, label.lastIndexOf(" ("))}</p>
    <p>{label.substring(label.lastIndexOf(" ("), label.length)}</p>
  </>

  return productURL ? (
    <a href={`${productOrigin}/${productURL}`} target='_blank' rel="noopener noreferrer">
      {updatedLabel}
    </a>
  ) : updatedLabel
}

export const updateProductSpec = (spec, hlcFlush, hangerType) => {
  const specCondition =
    spec.includes('TFD') ||
    (hangerType === HANGER_TYPE.TOP_FLANGE &&
      (spec.includes('SLD') || spec.includes('SLU')) &&
      (spec.includes('SKL') || spec.includes('SKR')))

  if (spec && specCondition) {
    const hlcFlushList = ['L', 'C', 'H']
    return spec + ' HLC' + hlcFlushList[hlcFlush]
  } else {
    return spec
  }
}

const getDimensions = (item) => {
  let match;
  const regex = /(SK|SL|TFD|TF|OS|HLC)(\w*)/g;
  const dimensions = {};

  while ((match = regex.exec(item.updatedSpec)) !== null) {
    const key = match[1];
    const value = match[2] || '';

    dimensions[key] = key === 'HLC' ? value + "0" : value;
  }

  return Object.values(dimensions).length ? { ...dimensions, W1: item.wSize, H1: item.hSize } : { W1: item.wSize, H1: item.hSize }
}


export const getHangersSummary = (jobs) => {
  return jobs.map((job) => {
    const dimensions = getDimensions(job)
    return Object.assign({ model: job.model, quantity: job.quantity }, job.updatedSpec ? { dimensions } : {})
  })
}

export const getFastenersSummary = (jobs) => {
  const fasteners = jobs.reduce((result, job) => {
    const {
      tfNail,
      jNail,
      hNail
    } = job;
    if (tfNail) result.push(tfNail)
    if (jNail) result.push(jNail)
    if (hNail) result.push(hNail)

    return result
  }, [])

  const summaryByType = fasteners.reduce((result, fastener) => {
    const fastenerByType = result.find(item => item.genericSku === fastener.type)

    if (fastenerByType) {
      fastenerByType.quantity = fastenerByType.quantity + fastener.quantity
    } else if (['Strong-Grip', 'PRONGS', 'SEE CATALOG'].includes(fastener.genericSku)) {
      return result;
    } else {
      const product = {
        genericSku: fastener.type,
        quantity: fastener.quantity,
        models: fastener.sellableSkus ?? ["*"]
      }

      result.push(product)
    }
    return result;
  }, [])

  return summaryByType
}

const getJobListSummary = (jobs) => {
  const summary = jobs.reduce((result, job) => {
    const formattedJob = {
      jobName: job.uid,
      [job.model]: job.quantity,
      model: job.model,
      quantity: job.quantity,
      ...job.jobInputs
    }

    result.push(formattedJob);

    return result;
  }, [])

  return summary
}

export const handleOrders = (jobs) => {
  const hangersSummary = getHangersSummary(jobs);
  const fastenersSummary = getFastenersSummary(jobs);
  const jobListSummary = getJobListSummary(jobs);

  const params = window.location.search ? queryString.parse(window.location.search) : {}

  const reply = {
    type: 'web-app-reply',
    data: {
      result: {
        models: hangersSummary,
        fasteners: fastenersSummary
      },
      jobList: jobListSummary
    }
  }

  window.parent.postMessage(reply, params.sourceDomain)
}

export const getFastenersTotal = (jobs) => {
  const fastenersSummary = getFastenersSummary(jobs)

  const fastenersTotal = fastenersSummary.reduce((total, entry) => {
    const fastener = SST_NAIL_ENUM.find(item => item.model === entry.genericSku);

    if(!fastener) return total;

    const fastenerLabel = `(${entry.quantity}) ${fastener.displayLabel ?? fastener.label}`;

    total.push(fastenerLabel)

    return total;
  }, [])

  return fastenersTotal;
}